export const ArticleReadScope = {
  System: 1,
  Content: 2,
}

export const ArticleReadScopeDisplayName = {
  [ArticleReadScope.System]: 'System',
  [ArticleReadScope.Content]: 'Content',
}
